export const APP = "/";
export const REGISTER_NEW_CANDIDATE = "/cadastro";
export const INFO_BASIC = `/informacao-basica`;
export const CONFIRME_REGISTER = `${REGISTER_NEW_CANDIDATE}/confirmacao-cadastro`;
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const FORGOT_PASSWORD = "/esqueceu-senha";
export const RECOVERY_PASSWORD = "/recuperar-senha";
export const CREATE_PASSWORD = "/cadastro-senha";
export const HOME = "/home";
export const MY_PROFILE = "/candidato/meu-perfil";
export const PERSONAL_INFORMATION = `${MY_PROFILE}?informacao-pessoal`;
export const ABOUT_YOU = `${MY_PROFILE}?sobre-voce`;
export const AVAILABILITY = `${MY_PROFILE}?disponibilidade`;
export const FORMATION = `${MY_PROFILE}?formacao`;
export const CAREER = `${MY_PROFILE}?carreira`;
export const SKILLS = `${MY_PROFILE}?competencias`;
export const LANGUAGES = `${MY_PROFILE}?linguas`;
export const PRE_ADMISSION = `${MY_PROFILE}?pre-admissao`;
export const CERTIFICATIONS = `${MY_PROFILE}?premios-e-certificacoes`;
export const SOCIAL_MEDIA = `${MY_PROFILE}?redes-sociais`;
export const INTERESTS = `${MY_PROFILE}?interesses`;
export const EDIT_PASSWORD = `${MY_PROFILE}?editar-senha`;
export const CANDIDATE_VACANCY = "/candidato/vaga";
export const START_TEST = "/iniciar-teste";
export const PAGE_REGISTRATIONDATA = "/dados-cadastrais";
export const TEST = "/teste";
export const PAGE_SEARCH = "/vagas/buscar";
export const VACANCIES = "/vagas";
export const SIGNATURE_REMOTE = "/signature/";
export const PRIVATE_ROUTERS = [
  MY_PROFILE,
  PERSONAL_INFORMATION,
  ABOUT_YOU,
  FORMATION,
  CAREER,
  SKILLS,
  LANGUAGES,
  CERTIFICATIONS,
  SOCIAL_MEDIA,
  INTERESTS,
  EDIT_PASSWORD,
  CANDIDATE_VACANCY,
  LOGIN,
  START_TEST
];
